import { useEffect } from "react";
import axios from "../utils/axios";
import useAuth from "./useAuth";


// send the auth token with every request 
const useAxiosAuth = () => {
    const {auth} = useAuth();

    useEffect(() => {
        // apply the auth token to axios
        const addTrailingSlashOnMethod = ['post', 'patch'];

        const requestInterceptors = axios.interceptors.request.use(config => {
            
            if (addTrailingSlashOnMethod.includes(config.method)) config.url += '/';
            
            config.headers.Authorization = `Bearer ${auth?.accessToken}`;
            return config;

        }, error => {
            return Promise.reject(error);
        });

        return () => {
            axios.interceptors.request.eject(requestInterceptors);
        };

    }, [auth?.accessToken]);

    return true;
};

export default useAxiosAuth;